export enum LoriOrderCodeType {
	AlphaNumeric = 1,
	NumericSequential = 2,
	UseExternalId = 3,
}
